import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de795977415867/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/node_modules/next/dist/client/link.js");
